import { render, staticRenderFns } from "./servicescomponents.vue?vue&type=template&id=28b84870&scoped=true"
import script from "./servicescomponents.vue?vue&type=script&lang=js"
export * from "./servicescomponents.vue?vue&type=script&lang=js"
import style0 from "./servicescomponents.vue?vue&type=style&index=0&id=28b84870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b84870",
  null
  
)

export default component.exports